import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  watch: {
    liveService: {
      handler(val) {
        if (val) {
          console.log("liveService", val);
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "signConfig",
      "roomInfo",
      "audioPermission",
      "videoPermission",
      "userStatus",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
  },
  methods: {
    ...mapMutations("live", ["setUserStatus"]),
    handleStartLocalPreviewByTestClient(params) {
      if (this.liveService) {
        return this.liveService.startLocalPreviewByTestClient(params);
      }
      return Promise.reject();
    },
    handleStopLocalPreviewByTestClient() {
      if (this.liveService) {
        return this.liveService.stopLocalPreviewByTestClient();
      }
      return Promise.reject();
    },
    handleSetCurrentCameraDeviceByTestClient(params) {
      if (this.liveService) {
        return this.liveService.setCurrentCameraDeviceByTestClient(params);
      }
      return Promise.reject();
    },
    handleSetCurrentMicDeviceByTestClient(params) {
      if (this.liveService) {
        return this.liveService.setCurrentMicDevice(params);
      }
      return Promise.reject();
    },
    handleSetCurrentSpeakerDeviceByTestClient(params) {
      if (this.liveService) {
        return this.liveService.setCurrentSpeakerDevice(params);
      }
      return Promise.reject();
    },
  },
};
